module.exports = __webpack_public_path__ + "static/img/banner.57a8d23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/IncentiveTravel/banner.png
// module id = obe6
// module chunks = 1